import React from 'react'

const Cross = ({color}) => {
  return (
    <svg viewBox="0 0 53.9 53.9">
      <path
        fill={color}
        d="M53.9,51L53.9,51L51,53.9l-24-24l-24,24l0,0l0,0L0,51l24-24L0,2.9l0,0l0,0L2.9,0l24,24L51,0l0,0l0,0l2.9,2.9L29.9,27
      L53.9,51L53.9,51z"/>
    </svg>
  )
}

export default Cross
